const initialUiConfig = {
    fullScreen: false,
    scrollLock: false,
    layout: 'default-layout',
    colorScheme: 'default',

    pageBackgroundColor: 'light',
    pageContainerBackgroundColor: 'white',
    pageFooterShow: true,
    pageHeaderShow: true,
    pageHeaderIsBoxed: false,
    pageHeaderBackgroundColor: 'transparent',
    pageColorSchemeType: 'light',

    leftSidebarHeight: 'full', // options: normal / full
    leftSidebarStyle: 'folded', // options: push / push-content / over / folded / off-canvas
    leftSidebarBackdrop: true,
    leftSidebarBackdropColor: 'dark', // options: transparent / dark / light
    leftSidebarShadow: false,
    leftSidebarColor: 'dark-primary',
    leftSidebarShow: false,
    leftSidebarLogoLight: true,
    
    rightSidebarHeight: 'full', // options: normal / full
    rightSidebarStyle: 'over', // options: push / push-content / over / folded / off-canvas
    rightSidebarBackdrop: false,
    rightSidebarBackdropColor: 'dark', // options: transparent / dark / light
    rightSidebarShadow: true,
    rightSidebarColor: 'white',
    rightSidebarShow: false,

    modalSidebarHeight: 'full', // options: normal / full
    modalSidebarStyle: 'over', // options: push / push-content / over / folded / off-canvas
    modalSidebarBackdrop: false,
    modalSidebarBackdropColor: 'dark', // options: transparent / dark / light
    modalSidebarShadow: true,
    modalSidebarColor: 'white',
    modalSidebarShow: false,

    configSidebarColor: 'light',
    configSidebarShow: false,
    specialSidebarColor: 'secondary',
    specialSidebarShow: false,

    topNavbarFixed: true,
    topNavbarHide: false,
    topNavbarColor: 'black',
    topNavbarLogoLight: true,
    
    navMenuThumbOnRight: false,
    navMenuLetterIcon: false,
    navMenuHorizontal: false,

    notificationPosition: 'bottom-right',
    notificationDuration: 5000,

    searchScreenShow: false,
    toggleRtl: false,

    wallpaper: null,
}

export default initialUiConfig
